import { render, staticRenderFns } from "./activity-404.vue?vue&type=template&id=1517380f&scoped=true"
import script from "./activity-404.vue?vue&type=script&lang=js"
export * from "./activity-404.vue?vue&type=script&lang=js"
import style0 from "./activity-404.vue?vue&type=style&index=0&id=1517380f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1517380f",
  null
  
)

export default component.exports